import { useInView } from 'react-intersection-observer';
import "animate.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faNode } from '@fortawesome/free-brands-svg-icons';
import { faJs } from '@fortawesome/free-brands-svg-icons';
import { faReact } from '@fortawesome/free-brands-svg-icons';
import { faGit } from '@fortawesome/free-brands-svg-icons';
import { faBootstrap } from '@fortawesome/free-brands-svg-icons';
import { faSass } from '@fortawesome/free-brands-svg-icons';
import { faFigma } from '@fortawesome/free-brands-svg-icons';
import { faMdb } from '@fortawesome/free-brands-svg-icons';
export default function SectionTwo(){

    const tools = [
        {
            id: 1,
            name: "React",
            icon: faReact
        },
        {
            id: 2,
            name: "Node",
            icon: faNode
        },
        {
            id: 3,
            name: "Javascript",
            icon: faJs
        },
        {
            id: 4,
            name: "MongoDB",
            icon: faMdb
        },
        {
            id: 5,
            name: "Figma",
            icon: faFigma
        },
        {
            id: 6,
            name: "Sass",
            icon: faSass
        },
        {
            id: 7,
            name: "Bootstrap",
            icon: faBootstrap
        },
        {
            id: 8,
            name: "Git",
            icon: faGit
        },
    ]

    const { ref, inView } = useInView({
        // triggerOnce: true, // Trigger the animation only once
        threshold: 0.1, // You can adjust this threshold value as needed
      });


    return (
        <section className="flex shadow flex-col items-center justify-start py-[50px]">
            <div 
            className={`uppercase rotate-[10deg] cyborg px-[20px] bg-[#12141d] toolingBox py-[15px] text-[30px]`}>
                tools
            </div>

            <section
            className={`grid grid-cols-2 grid-rows-4 mt-[60px] sm:grid-cols-4 sm:grid-rows-2 
         bg-[#0c8c34] p-[10px] rounded-[15px] flex flex-row justify-center items-center w-[90%] sm:w-[70%]`}
         
      ref={ref}
         >
                {
                    tools?.map((tool, id) => (
                        <div key={id} className={`text-white font-[900] text-[15px] sm:text-[20px] expoSpace bg-[#021709] px-[20px]
                         w-[95%] flex flex-row items-center justify-start h-[50px] rounded-[10px] ${tool?.id > 4 ? "" : "mb-[10px]"} `}>
                        
                        <FontAwesomeIcon icon={tool?.icon} style={{color: "#0c8c34",}} />
                        <h1 className='pl-[20px]'>{tool?.name}</h1>
                        </div>
                    ))
                }
            </section>
        </section>
    )
}